import { BRANCH_HEADER } from "@shared/branches";

const STORAGE_KEY = "pos-active-branch-id";

export function getStoredBranchId(): number | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const id = Number.parseInt(raw, 10);
    return Number.isFinite(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}

export function setStoredBranchId(id: number): void {
  localStorage.setItem(STORAGE_KEY, String(id));
}

export function clearStoredBranchId(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function getBranchHeaders(): Record<string, string> {
  const id = getStoredBranchId();
  return id ? { [BRANCH_HEADER]: String(id) } : {};
}

/** Fetch wrapper that attaches x-branch-id and session cookies */
export async function apiFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);
  for (const [key, value] of Object.entries(getBranchHeaders())) {
    headers.set(key, value);
  }
  return fetch(input, {
    ...init,
    headers,
    credentials: init?.credentials ?? "include",
  });
}
